export default __webpack_public_path__ + "static/media/Migraine-2.0390cce5.jpg";